import { TrashIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useRolodexEdit } from 'features/fde'
import { useKestrel } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVCameraView, RolodexEntryPatchJson } from 'types'

const StyledTrashIcon = styled(TrashIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const DeleteCameraViewButton: FC<{
  cameraViewId: string
}> = ({ cameraViewId }) => {
  const {
    sendKVCommand,
    selectedMarkup,
    setSelectedMarkup,
    kestrelModel,
    cameraViews,
    setCameraViews,
  } = useKestrel()
  const { rolodexPatch } = useRolodexEdit()

  const deleteCameraView = (e: React.MouseEvent) => {
    e.stopPropagation()
    let filteredCameraViews: KVCameraView[] = []
    if (cameraViews) {
      filteredCameraViews = cameraViews.filter((a) => a.id !== cameraViewId)
    }
    if (sendKVCommand) {
      setCameraViews(filteredCameraViews)
      sendKVCommand({
        command: KestrelCommands.DELETE_CAMERA_VIEW,
        cameraViewId,
      })
      if (selectedMarkup?.id === cameraViewId) setSelectedMarkup(undefined)

      // Delete from Rolodex
      if (kestrelModel?.id) {
        const patchData: RolodexEntryPatchJson = {
          id: kestrelModel.id,
          data: {
            cameraViews: filteredCameraViews.map((view) =>
              KVCameraView.toJSON(view)
            ),
          },
        }
        rolodexPatch([patchData])
      }
    }
  }

  return (
    <TooltipWrapper side={'top'} label={'Delete camera view'}>
      <div
        style={{ cursor: 'pointer', marginLeft: '-4px' }}
        onClick={(e) => deleteCameraView(e)}
        data-action-button='true'>
        <StyledTrashIcon width={22} height={22} />
      </div>
    </TooltipWrapper>
  )
}
